import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/PINCodeAuthentication.css'; // Import the CSS file

class PINCodeAuthentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: ['', '', '', '', '', ''],
      message: '',
      errorMessage: '',
      isSubmitting: false,
      token: null // Store the generated token
    };
  }

  handleOTPChange = (e, index) => {
    const { value } = e.target;
    if (isNaN(value) || value.length > 1) return;

    const newOTP = [...this.state.otp];
    newOTP[index] = value;
    this.setState({ otp: newOTP });

    // Move to the next input field if a digit is entered
    if (value && index < 5) {
      this[`otpInput${index + 1}`].focus();
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });

    const otp = this.state.otp.join('');

    try {
      const response = await axios.post('/pin-auth', { pinCode: otp });

      if (response.status === 200) {
        this.setState({
          message: response.data.message,
          errorMessage: '',
          isSubmitting: false,
          token: response.data.token // Save the token in the state
        });

        // Store the token in local storage or session storage
        localStorage.setItem('authToken', response.data.token);

        // Wait for 3 seconds before redirecting
        setTimeout(() => {
          // Redirect to ShowTokens route with token
          this.props.history.push('/showtokens', { token: response.data.token });
        }, 3000);
      } else {
        this.setState({ errorMessage: response.data.message, message: '', isSubmitting: false });
      }
    } catch (error) {
      if (error.response) {
        this.setState({ errorMessage: error.response.data.message, message: '', isSubmitting: false });
      } else {
        this.setState({ errorMessage: "An error occurred. Please try again later.", message: '', isSubmitting: false });
      }
    }
  }

  render() {
    return (
      <div className="token-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <br />
          <h2>PIN Code Authentication</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group pin-input-group">
                      {this.state.otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          className="form-control pin-input"
                          value={digit}
                          onChange={(e) => this.handleOTPChange(e, index)}
                          ref={(input) => this[`otpInput${index}`] = input}
                          maxLength="1"
                          required
                        />
                      ))}
                    </div>
                    <button type="submit" className="btn btn-dark" disabled={this.state.isSubmitting}>
                      {this.state.isSubmitting ? 'Submitting...' : 'Submit PIN'}
                    </button>
                  </form>
                  {this.state.message && <div className="alert alert-success mt-3">{this.state.message}</div>}
                  {this.state.errorMessage && <div className="alert alert-danger mt-3">{this.state.errorMessage}</div>}
                  <div className="text-center mt-3">
                    <div>Powered by</div>
                    <img className='logo2' src={logo2} alt="Logo 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PINCodeAuthentication);
